<!-- 卸车管理 -->
<template>
    <div class='page_content'>
        <el-drawer :close-on-press-escape="true" :visible.sync="showStatus" :with-header="false" append-to-bodycustom-class="drawer_box" direction="ltr" size="100%">
            <unloadingListRecordAction v-if="showStatus" ref="unloadingListRecordAction" @drawerCancel="drawerCancel" @toDetail="toDetail" :actionData="actionData"></unloadingListRecordAction>
        </el-drawer>

        <div class="page_content_top">
            <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo" @openFormDesign="openFormDesign"></v-button>
            <div class="page_content_top_line">
                <v-search v-if="pageShowData.jurHead" :searchList="pageShowData.jurHead.jurconfigform" :getRequestData="getRequestData" @searchData="searchData" @openSearch="openSearch">

                </v-search>
            </div>
        </div>
        <div class="page_content_center">
            <el-table @selection-change="handleSelectionChange" v-if="pageShowData.jurTableVo" stripe :data="returnData.list" :height="tableHeight" :key="$store.state.tableNum" border style="width: 100%"
                      highlight-current-row size="mini">
                <el-table-column align="center" label="选择操作" width="80">
                    <template slot-scope="scope">
                        <el-radio v-model="selectedDataIndex" :label="scope.$index" border size="mini">
                            <i class="el-icon-thumb"></i>
                        </el-radio>
                    </template>
                </el-table-column>
                <template v-for="(tableValye, tableKey) in pageShowData.jurTableVo.jurconfigtable">
                    <el-table-column align="center" v-if="tableValye.isShow == 1" :key="tableKey" show-overflow-tooltip :prop="tableValye.entityField" :min-width="tableValye.fieldWeight" :label="tableValye.showField">
                        <template slot="header">
                            <div>
                                <el-tooltip :disabled="isShowTooltip" :content="tableValye.showField" placement="top">
                                    <div class="long_title"><span :ref="tableValye.entityField">{{ tableValye.showField
                                        }}</span></div>
                                </el-tooltip>
                            </div>
                        </template>
                        <template slot-scope="scope">
                            <el-tag size="mini" v-if="tableValye.entityField == 'isWms'">
                                {{ scope.row.isWms == 0 ? '否' : '是' }}
                            </el-tag>
                            <el-tag size="mini" v-else-if="tableValye.entityField == 'psomState'">
                                {{ $common.getIsGsp(tableValye.formatterContent, scope.row.psomState) }}</el-tag>
                            <span v-else-if="tableValye.entityField == 'createTime'">
                                <span v-if="scope.row[tableValye.entityField]">
                                    {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                                </span>
                            </span>
                            <span v-else-if="tableValye.isRift == 1">
                                <a @click="toDetail(scope.row[tableValye.riftField])">{{ scope.row[tableValye.entityField]
                                }}</a>
                            </span>
                            <span v-else>
                                {{ scope.row[tableValye.entityField] }}
                            </span>
                        </template>
                    </el-table-column>
                </template>
            </el-table>
        </div>
        <div class="page_content_bottom">
            <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total" @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>

        </div>
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
            <SearchScheme ref="searchScheme" :id="seId" @TranData="changeInputModel" @getWidth="getSeWidth" :parentSearchData="parentSearchData" @sendTitle="getSearchName" />
        </el-dialog>
        <printPlan ref="printPlan"></printPlan>
        <!-- 自定义设计 -->
        <customDesign ref="customDesign"></customDesign>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "../../../byComponents/SearchScheme.vue"
import unloadingListRecordAction from '@/components/unloadingListRecordAction.vue'
export default {
    //import引入的组件需要注入到对象中才能使用
    components: {
        SearchScheme,
        unloadingListRecordAction
    },
    data() {
        //这里存放数据
        return {
            tableHeight: 0,
            getRequestData: {},
            returnData: {
                pages: 0, // 总页数
                total: 0, // 总条数
                pageNum: 0, // 当前页数
                list: []
            },
            buttonList: [],
            pageShowData: [],
            formDataList: [],
            selectedDataIndex: 0,
            DialogVisible: false, //检索
            seWidth: '0',
            seId: 0,
            seTitle: "",
            sField: "",
            smId: '',
            isShowTooltip: false,
            showStatus: false,
            actionData: [],
            selectData: [],
            parentSearchData: {}
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {

        handleSelectionChange(val) {
            this.selectData = val
        },
        // 子组件触发
        drawerCancel() {
            this.showStatus = false
            this.getDataList()
        },
        // 点击穿透字段 传参单号
        toDetail(orderId) {
            //    console.log(orderId)
            if (orderId) {
                // 设置为true 打开穿透组件首页    
                var isPenetrate = true
                // 设置缓存 存入点击单号
                this.resetSetItem('penetrateOrderId', orderId);
                // 与父级跨域通信 传递isPenetrate参数
                window.parent.postMessage({ //向窗口发送MessageEvent消息
                    cmd: 'returnFormJson',
                    params: {
                        isPenetrate
                    } //参数
                }, '*');
            }

        },

        // 检索Id, 索引(表格中), 标识
        openSearch({ sId, index, type, sField }) {
            this.DialogVisible = true
            this.seId = sId
            this.sField = sField
            this.parentSearchData[type] = this.getRequestData[type]

        },
        //检索返回
        changeInputModel(val) {
            console.log('返回', val);
            if (val != "" || val != undefined) {
                this.DialogVisible = false;
                this.paramValue(val)
            }
        },
        // 赋值字段
        paramValue(val) {
            let arr = this.sField.split(",");
            arr.forEach((item) => {
                this.getRequestData[item] = val[item];
            });
        },
        getSeWidth(e) {
            this.seWidth = e + "%";
        },
        getSearchName(e) {
            this.seTitle = e;
        },

        // 动作集合
        actionSet(actionData) {
            switch (actionData.actionType) {
                case 0:
                    if (this.selectData.length < 1) {
                        this.$message({
                            message: '请先选中要操作的数据',
                            type: 'error'
                        });
                        return false
                    }
                    this.actionData = [0, this.formDataList, this.selectData]
                    this.showStatus = true
                    break;
                case 1:
                    if (!this.selectData.length) {
                        this.$message({
                            message: '请先选中要操作的数据',
                            type: 'error'
                        });
                        return false
                    }
                    this.showStatus = true
                    this.actionData = [1, this.formDataList, dataInfo]
                    break;
                case 2:
                    this.delDataAction()
                    break;
                case 3://导出
                    this.exportMethod()
                    break;
                case 8:
                    this.showPrintPlan()
                    break;

            }
        },
        exportMethod() {
            this.ormId = sessionStorage.getItem('ormId')
            const params = JSON.parse(JSON.stringify(this.getRequestData))
            params.ormId = this.ormId
            delete params.rows
            delete params.page
            console.log(`${this.$store.getters.getConfig.requestUrl}/unload/export${this.$common.getUrl(params)}`);

            // return
            window.location.href = `${this.$store.getters.getConfig.requestUrl}/unload/export${this.$common.getUrl(params)}`
        },
        openFormDesign() {
            let pathInfo = parent.getMenuInfo(this.$route.path)
            this.$refs['customDesign'].openBox(pathInfo.jurId, this.pageShowData, pathInfo.jurName)
        },
        // 删除数据
        delDataAction() {
            var dataInfo = this.returnData.list[this.selectedDataIndex];
            if (!dataInfo) {
                this.$message({
                    message: '请先选中要操作的数据',
                    type: 'error'
                });
                return false
            }

            this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                var delData = {
                    ids: [this.returnData.list[this.selectedDataIndex].unloadId]
                }
                let responseData = await this.$http.unloadDelete(delData)
                if (responseData.status == 200) {
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    });

                    this.getDataList()
                } else {
                    this.$message({
                        message: responseData.message,
                        type: 'error'
                    });
                }

            }).catch(() => { });
        },
        //打印
        showPrintPlan() {
            if (this.selectData.length !== 1) {
                this.$message({
                    message: '请选中一条要操作的数据',
                    type: 'error'
                });
                return false
            }
            // 调用全局方法 判断Websocket是否连接
            if (this.$printSocketApi.printExeMsg() != false) {
                // 选中的数据
                var info = this.selectData
                this.$refs.printPlan.openDia(info.traId)
            } else {
                return
            }
        },
        // 数据搜索
        searchData() {
            this.getRequestData.page = 1
            this.getDataList()
        },
        // 数据翻页
        setDataPageNumber(val) {
            this.getRequestData.page = val
            this.getDataList()
        },

        // 切换显示条数
        setDataPageSize(val) {
            this.getRequestData.page = 1
            this.getRequestData.rows = val
            this.getDataList()
        },

        // 获取数据列表
        async getPageInfo() {
            var pathId = parent.getMenuInfo(this.$route.path)
            let responseData = await this.$http.getJur({
                ids: [pathId.jurId]
            })
            console.log(responseData);
            if (responseData.status == 200) {
                this.pageShowData = responseData.result
                var obj = {}
                if (this.pageShowData.jurHead) {
                    obj = this.$common.getSearchData(this.pageShowData.jurHead.jurconfigform, 'page', "rows", 30)
                } else {
                    obj = this.$common.getSearch(this.getRequestData, 'start', 'end', 'page', 'rows', 30)
                }
                for (const key in obj) {
                    this.$set(this.getRequestData, key, obj[key])
                }
                this.formDataList = this.pageShowData.jurFormVoList
                this.formDataList[1].isShowForm = 1
                this.getDataList();
                this.getButtonList();
            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },

        // 获取数据列表
        async getDataList() {
            let responseData = await this.$http.unloadRecordQuery(this.getRequestData)
            if (responseData.status == 200) {
                this.returnData.list = responseData.result.list
                this.returnData.pages = responseData.result.pages
                this.returnData.total = responseData.result.total
                this.returnData.pageNum = responseData.result.pageNum
                this.selectedDataIndex = 0
            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },

        //获取状态
        getIsGsp(str, val) {
            try {
                if (str.indexOf('[') === -1) return val
                str && str.replace(/\\/g, '')
                let arr = JSON.parse(str)
                let len = arr.length
                let newStr = ''
                for (let i = 0; i < len; i++) {
                    if (arr[i].key == val) {
                        newStr = arr[i].value
                        break;
                    }
                }
                return newStr ? newStr : val
            } catch (ex) {
                return val
            }
        },

        // 获取按钮权限
        async getButtonList() {
            this.buttonList = await this.$common.getActionButton()
            
        },
},
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.getPageInfo()
        this.getButtonList()
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style scoped>
.table_content_tag {
    margin-right: 1rem;
}

.el-tabs--border-card_new {
    height: 85vh;
    overflow-y: scroll;
}

.el-drawer {
    outline: none;
}
</style>